import { useClients } from '@src/clients/hooks/useClients';
import { ManageClients } from '@src/clients/ManageClients';

export const AdminManageClients = ({
  addClientPageLink,
}: {
  addClientPageLink: string;
}) => {
  const { clientList } = useClients();
  return (
    <ManageClients
      addClientPageLink={addClientPageLink}
      clientList={clientList}
      canArchive={true}
    />
  );
};
